'use strict';

const React = require('react'),
    {PropTypes} = require('react');


const CarouselItem = React.createClass({displayName: "CarouselItem",
    propTypes: {
        className: PropTypes.string,
        imageStyle: PropTypes.obj,
        imageSrc: PropTypes.string,
        name: PropTypes.string,
        link: PropTypes.string,
        linkHoverName: PropTypes.string,
        onClick: PropTypes.func
    },

    render() {
        const {imageSrc, link, linkHoverName, className, onClick, imageStyle} = this.props;
        return (
            React.createElement("li", {onClick: onClick, className: 'bp-carousel-item' + (className ? ' ' + className : '')}, 
                React.createElement("a", {target: "_blank", name: linkHoverName, href: link}, 
                    React.createElement("div", {style: Object.assign({},{backgroundImage: 'url(' + imageSrc + ')'}, imageStyle), className: "bp-carousel-item__image"}
                    )
                )
            )
        );
    }
});


module.exports = CarouselItem;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Carousel/CarouselItem/CarouselItem.jsx
 **/